import styled, { keyframes, css } from 'styled-components';
import { Box, Chip, TableCell } from '@mui/material';

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
`;

export const JobsTableContainer = styled(Box)`
  width: 100%;
  margin-top: 16px;

  .MuiTableContainer-root {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
  }

  .MuiTableHead-root {
    background-color: #f5f5f5;
  }

  .MuiTableCell-head {
    font-weight: 600;
    color: #333;
    font-size: 0.875rem;
  }

  .MuiTableRow-hover:hover {
    background-color: #f9f9f9;
  }
`;

export const StatusChip = styled(Chip)`
  font-weight: 500;
  font-size: 0.75rem;
`;

export const LoadingCell = styled(TableCell)<{ isLoading: boolean }>`
  ${({ isLoading }) => isLoading && css`
    animation: ${pulse} 2s ease-in-out infinite;
  `}
`;
